<div class="ht-container" style="position:relative">

  <!-- HR Navigation Header -->
  <div class="lp-nav-header">
    <button class="lp-nav-tab" [routerLink]="['/ers/leave-management/manage-leave-policies']">
      {{ 'leave_management.manage_holidays.leave_allocate_amp_policies' | transloco }}
    </button>
    <button class="lp-nav-tab lp-nav-tab--active" [routerLink]="['/ers/leave-management/manage-holidays']">
      {{ 'leave_management.manage_holidays.holidays' | transloco }}
    </button>
  </div>

  <!-- Header -->
  <div class="ht-header">
    <div class="ht-header-left">
      <span class="ht-title">{{ 'leave_management.manage_holidays.company_holidays' | transloco }}</span>
    </div>
    <div class="ht-header-right">
      <button class="lm-btn lm-btn--primary" (click)="onCreateNewHoliday()">
        <span class="material-icons" style="font-size:18px;line-height:1;vertical-align:middle">{{ 'leave_management.manage_holidays.add' | transloco }}</span>
        {{ 'leave_management.manage_holidays.create_new_holiday' | transloco }}
      </button>
      <button class="lm-btn lm-btn--outline ht-btn-secondary" (click)="onUseLastYear()" disabled>
        <span class="material-icons ht-btn-icon">{{ 'leave_management.manage_holidays.history' | transloco }}</span>
        {{ 'leave_management.manage_holidays.use_last_year' | transloco }}
      </button>
    </div>
  </div>

  <lm-loading-overlay [show]="isLoading || isSaving" [message]="isSaving ? 'Saving...' : 'Loading holidays...'"></lm-loading-overlay>

  <!-- Holidays Grid -->
  <div class="ht-grid-wrapper">
    <ers-grid
      [rowData]="holidays"
      [columnDefs]="colDefs"
      [gridOptions]="gridOptions"
      (cellClicked)="onCellClick($event)">
    </ers-grid>
  </div>

</div>
